import React from 'react'
import styled from 'styled-components'
import { ArrowSlim } from './ArrowSlim'
import { SubMenu } from './SubMenu'
import { linkStyles, linkStylesHover, linkStylesHoverBg } from './styles'
import { size } from './platform'
import type { MenuListElement } from './menuList'

const Dot = styled.div`
  height: 4px;
  width: 4px;
  border-radius: 2px;
  background-color: #000;
  margin-right: 1em;
  display: none;
`

type MenuItemProps = {
  element: MenuListElement
  key: string
  level: number
  className?: string
  right?: boolean
}

export const MenuItem = styled(
  ({ element, key, className, level }: MenuItemProps) => {
    const getContent = () => {
      if ('path' in element) {
        return (
          <a href={element.path}>
            <Dot />
            {element.icon}
            {element.name}
          </a>
        )
      }

      if ('onClick' in element) {
        return (
          <button onClick={element.onClick} type="button">
            {element.icon}
            {element.name}
          </button>
        )
      }

      return (
        <>
          <a>
            {element.icon}
            {element.name}
            <span className="drop-icon">
              <ArrowSlim />
            </span>
          </a>
          <SubMenu key={key} level={level}>
            {element.children}
          </SubMenu>
        </>
      )
    }

    const content = getContent()

    return (
      <li key={key} className={className}>
        {content}
      </li>
    )
  }
)`
  position: relative;
  display: block;
  padding-top: 0px;
  padding-bottom: 0px;
  float: left;
  border-width: 0 1px 0 0;
  label.drop-icon {
    position: absolute;
    right: 1.5em;
    top: 1.25em;
  }

  // Nested menu selector
  & > ul > li > ul {
    margin-top: 0;
    margin-left: 100%;
    top: 0;
    left: 0;
  }

  @media only screen and (min-width: ${size.md}) {
    ${(props) => `margin-left: ${props.right ? 'auto' : 'unset'};`}
    ${(props) => props.level === 1 && 'display: flex;'}
  }

  & > button {
    width: 100%;
  }

  & > a,
  & > button {
    ${linkStyles}
    ${linkStylesHover}
    ${(props) => props.level > 1 && `${linkStylesHoverBg}padding: 8px 16px;`}
    display: flex;
    align-items: center;
    position: relative;
    transition: all 0.125s ease-in-out;
    -webkit-transition: all 0.125s ease-in-out;
    display: flex;
    align-items: center;
    > span.drop-icon {
      ${(props) =>
        props.level === 1 &&
        'transform: rotate(-90deg); transition: transform 0.2s ease;'}
    }
  }

  &:hover > a > span.drop-icon {
    ${(props) =>
      props.level === 1 &&
      'transform: rotate(90deg); transition: transform 0.2s ease;'}
  }

  @media only screen and (max-width: ${size.md}) {
    // Nested menu selector
    & > ul > li > ul {
      margin-left: 0%;
    }

    &:hover > a > span.drop-icon {
      transform: rotate(90deg);
      transition: transform 0.2s ease;
    }

    ${Dot} {
      ${(props) => props.level === 3 && 'display: block;'}
    }

    & > a,
    & > button {
      display: flex;
      align-items: center;
      padding-left: 2em;
      padding-right: 2em;
      font-family: Montserrat, sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      height: 48px;
      background-color: transparent;
      border: none;
      text-decoration: none;
      color: rgb(51, 51, 51);
      white-space: normal;
      gap: 4px;
      cursor: pointer;
      &:hover {
        background-color: #f6f6f6;
        color: #03b2a5;
      }
      ${(props) =>
        props.level === 3 &&
        'font-size: 14px; font-weight: 500; padding-left: 3em;'}
    }
  }
`
